import { SimpleGrid, Text, Center } from "@mantine/core";
import { ApartmentCard } from "./ApartmentCard";
import type { Apartment, PriceChange } from "@/api/types";

interface ApartmentGridProps {
  apartments: Apartment[];
  priceChanges?: PriceChange[];
  lastElementRef?: (node: HTMLElement | null) => void;
}

export function ApartmentGrid({
  apartments,
  priceChanges = [],
  lastElementRef,
}: ApartmentGridProps) {
  const priceChangeMap = new Map(priceChanges.map((pc) => [pc.apartment_id, pc]));

  if (apartments.length === 0) {
    return (
      <Center py="xl">
        <Text c="dimmed">No apartments found</Text>
      </Center>
    );
  }

  return (
    <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md">
      {apartments.map((apartment, index) => (
        <div key={apartment.id} ref={index === apartments.length - 1 ? lastElementRef : undefined}>
          <ApartmentCard apartment={apartment} priceChange={priceChangeMap.get(apartment.id)} />
        </div>
      ))}
    </SimpleGrid>
  );
}
